import { render, staticRenderFns } from "./MethodOfCollectionList.vue?vue&type=template&id=22c778ff&"
import script from "./MethodOfCollectionList.vue?vue&type=script&lang=js&"
export * from "./MethodOfCollectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports